import { LineItem } from 'utils/types';

const stripePublicKey: string =
  // @ts-ignore
  (typeof window !== 'undefined' && window.stripePublicKey) ||
  process.env.STRIPE_PUBLIC_KEY;

// Enable Express payments on normal items, subscription, and single membership orders
// Disable Express payments on orders with both a subscription/membership order + a normal item
const hasSubscriptionItemInCart = (
  lineItems: LineItem[] | undefined,
): boolean => !!lineItems?.some((li) => li.is_subscription);

// Has at least one lab visit item in cart
const hasLabVisitItemInCart = (lineItems: LineItem[] | undefined): boolean =>
  !!lineItems?.some((item) => item.is_lab_visit);

export { stripePublicKey, hasSubscriptionItemInCart, hasLabVisitItemInCart };
